module.exports = __webpack_public_path__ + "static/img/step1.b4b4396d.png";